/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = routeMetched => {
    let res = routeMetched.map(item => {
        return {
            icon: (item.meta && item.meta.icon) || '',
            name: item.name,
            meta: item.meta,
        };
    });
    res = res.filter(item => item.name != 'index' && item.name != 'home');
    return [
        {
            name: 'home',
            to: '/home',
        },
        ...res,
    ];
};

/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
export const getMenuByRouter = (list, userAccess) => {
    let res = [];
    list.forEach(item => {
        if (item.meta && !item.meta.hideInMenu) {
            let userMenu = userAccess.find(p => p.routerName == item.name);
            if (userMenu !== undefined) {
                let obj = {
                    icon: userMenu.icon || (item.meta && item.meta.icon),
                    name: item.name,
                    sort: userMenu.sortOrder,
                    meta: item.meta,
                };
                if (item.children && item.children.length !== 0) {
                    obj.children = getMenuByRouter(item.children, userAccess);
                }
                res.push(obj);
            }
        }
    });
    return res.sort((a, b) => parseInt(a.sort) - parseInt(b.sort));
};

/**
 * @param {Array} router 路由
 * @param {Array} userAccess 用户权限
 * @returns {Boolean}
 */
const showThisMenuEle = (router, userAccess) => {
    return userAccess.some(p => p.routerName == router.name);
};

/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
export const getTagNavListFromLocalstorage = () => {
    let tagList = localStorage.tagNaveList ? JSON.parse(localStorage.tagNaveList) : [];
    if (tagList.every(tag => tag.name != 'home')) {
        tagList.unshift({
            name: 'home',
            path: '/home',
            meta: { hideInMenu: true, isCache: true },
        });
    }
    return tagList;
};
/**
 * @description 本地存储和获取标签导航列表
 */
export const setTagNavListInLocalstorage = list => {
    localStorage.tagNaveList = JSON.stringify(list);
};

/**
 * @returns {} 获取锁定情况
 */
export const getLockInfoFromLocalstorage = () => (localStorage.lockInfo ? JSON.parse(localStorage.lockInfo) : {});

/**
 * @returns {} 設定锁定情况
 */
export const setLockInfoInLocalstorage = lockInfo => (localStorage.lockInfo = JSON.stringify(lockInfo));
